import { render, staticRenderFns } from "./top-menu.vue?vue&type=template&id=ab70fd94&scoped=true&"
import script from "./top-menu.vue?vue&type=script&lang=js&"
export * from "./top-menu.vue?vue&type=script&lang=js&"
import style0 from "./top-menu.vue?vue&type=style&index=0&id=ab70fd94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab70fd94",
  null
  
)

export default component.exports